import react from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import ScrollToHash from "./utils/ScrollToHash";

import TopNav from "./components/TopNav";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <div className="appLayout">
        <ScrollToHash />
        <TopNav />

        <main className="appContent">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
